import { addWeeks, eachDayOfInterval, isSameDay } from 'date-fns';
import { map, Observable } from 'rxjs';
import { inject } from '@angular/core';
import { DateFormats, formatDateToString } from '@core';
import { CalendarHeader, FiltersValues } from '../../../models';
import { FiltersStorage } from '@find-games/infra';

export class GetFilterDaysQueryHandler {
  private readonly filtersStorage: FiltersStorage = inject(FiltersStorage);

  filterDays(): Observable<CalendarHeader[]> {
    const startDate: Date = new Date();
    const endDate: Date = addWeeks(startDate, 2);

    const availableRange: Date[] = eachDayOfInterval({
      start: startDate,
      end: endDate
    });

    return this.filtersStorage.filters$.pipe(
      map((filters: FiltersValues) => {
        return availableRange.map((day: Date) => {
          return {
            dayAbbreviation: formatDateToString(day, DateFormats.WeekdayShort),
            date: formatDateToString(day, DateFormats.DayShortMonth),
            isSelected: isSameDay(day, filters.specificDate),
            value: day
          };
        });
      })
    );
  }
}
